module.exports = __webpack_public_path__ + "static/media/exclamation.b6106eeb.svg";